import { useEffect, useRef, useState } from 'react';

export default function WinShareCard({ playerName, prizePool, tournamentId, onClose }) {
  const canvasRef = useRef(null);
  const [ready, setReady] = useState(false);

  const prize = `$${(Number(prizePool) * 0.9 / 1_000_000).toFixed(2)} USDC`;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    const W = 1200, H = 630;

    // Background
    const bg = ctx.createLinearGradient(0, 0, W, H);
    bg.addColorStop(0, '#0a0a0f');
    bg.addColorStop(1, '#0f0f1a');
    ctx.fillStyle = bg;
    ctx.fillRect(0, 0, W, H);

    // Glow
    const glow = ctx.createRadialGradient(W/2, H/2, 0, W/2, H/2, 500);
    glow.addColorStop(0, 'rgba(139,0,255,0.15)');
    glow.addColorStop(0.5, 'rgba(0,212,255,0.07)');
    glow.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = glow;
    ctx.fillRect(0, 0, W, H);

    // Corner accents
    function corner(x, y, dx, dy, color) {
      ctx.strokeStyle = color;
      ctx.lineWidth = 3;
      ctx.beginPath();
      ctx.moveTo(x + dx * 24, y); ctx.lineTo(x, y); ctx.lineTo(x, y + dy * 24);
      ctx.stroke();
    }
    corner(32, 32,   1,  1, 'rgba(0,212,255,0.8)');
    corner(W-32, 32, -1,  1, 'rgba(0,212,255,0.8)');
    corner(32, H-32,  1, -1, 'rgba(255,0,110,0.8)');
    corner(W-32, H-32,-1, -1,'rgba(255,0,110,0.8)');

    const grad = ctx.createLinearGradient(200, 0, 1000, 0);
    grad.addColorStop(0,   '#00D4FF');
    grad.addColorStop(0.5, '#8B00FF');
    grad.addColorStop(1,   '#FF006E');

    // Trophy
    ctx.font = '90px serif';
    ctx.textAlign = 'center';
    ctx.fillText('🏆', W/2, 165);

    // WINNER label
    ctx.font = '700 16px Arial';
    ctx.fillStyle = '#00D4FF';
    ctx.letterSpacing = '6px';
    ctx.fillText('TOURNAMENT WINNER', W/2, 210);

    // Player name
    ctx.font = '900 72px "Arial Black", Arial';
    ctx.fillStyle = '#ffffff';
    ctx.shadowColor = '#8B00FF';
    ctx.shadowBlur = 24;
    ctx.fillText(playerName, W/2, 300);
    ctx.shadowBlur = 0;

    // Separator
    const sep = ctx.createLinearGradient(200, 0, W-200, 0);
    sep.addColorStop(0, 'rgba(0,212,255,0)');
    sep.addColorStop(0.3, '#00D4FF');
    sep.addColorStop(0.7, '#FF006E');
    sep.addColorStop(1, 'rgba(255,0,110,0)');
    ctx.strokeStyle = sep;
    ctx.lineWidth = 2;
    ctx.beginPath(); ctx.moveTo(200, 330); ctx.lineTo(W-200, 330); ctx.stroke();

    // Prize
    ctx.font = '400 22px Arial';
    ctx.fillStyle = 'rgba(255,255,255,0.6)';
    ctx.fillText('WON', W/2, 378);

    ctx.font = '900 86px "Arial Black", Arial';
    ctx.fillStyle = grad;
    ctx.fillText(prize, W/2, 468);

    // Tournament ID
    ctx.font = '600 16px Arial';
    ctx.fillStyle = 'rgba(255,255,255,0.3)';
    ctx.fillText(`Tournament #${tournamentId}  ·  Paid on Polygon`, W/2, 518);

    // EZGAME branding
    ctx.font = '900 22px "Arial Black", Arial';
    ctx.fillStyle = grad;
    ctx.fillText('EzEgames', W/2, 574);

    ctx.font = '500 14px Arial';
    ctx.fillStyle = 'rgba(255,255,255,0.25)';
    ctx.fillText('www.ezegames.live', W/2, 598);

    setReady(true);
  }, [playerName, prizePool, tournamentId]);

  function download() {
    const a = document.createElement('a');
    a.download = `ezgame-win-${tournamentId}.png`;
    a.href = canvasRef.current.toDataURL('image/png');
    a.click();
  }

  function shareTwitter() {
    const text = `🏆 I just won ${prize} on @EZ_Egames!\n\nOne ranked Apex match. Instant USDC payout on Polygon.\n\nPlay at ezegames.live 👇`;
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`, '_blank');
  }

  const s = {
    overlay: {
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
      zIndex: 1000, display: 'flex', alignItems: 'center',
      justifyContent: 'center', padding: 24, flexDirection: 'column', gap: 20,
    },
    canvas: { maxWidth: '100%', borderRadius: 12, border: '1px solid #00D4FF33' },
    btns: { display: 'flex', gap: 12, flexWrap: 'wrap', justifyContent: 'center' },
    btnPrimary: {
      padding: '12px 28px', border: 'none', borderRadius: 8, fontSize: 14,
      fontWeight: 700, color: '#fff', cursor: 'pointer',
      background: 'linear-gradient(270deg,#00D4FF,#8B00FF,#FF006E)',
      backgroundSize: '400% 400%', animation: 'gradientShift 4s ease infinite',
    },
    btnGhost: {
      padding: '12px 28px', border: '1px solid #ffffff22', borderRadius: 8,
      fontSize: 14, fontWeight: 600, color: '#aaa', cursor: 'pointer',
      background: 'transparent',
    },
  };

  return (
    <div style={s.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <canvas ref={canvasRef} width={1200} height={630} style={s.canvas} />
      {ready && (
        <div style={s.btns}>
          <button style={s.btnPrimary} onClick={shareTwitter}>𝕏 Share on X</button>
          <button style={s.btnPrimary} onClick={download}>⬇ Download PNG</button>
          <button style={s.btnGhost} onClick={onClose}>Close</button>
        </div>
      )}
    </div>
  );
}
